// extracted by mini-css-extract-plugin
export default {"text":"pageAboutUs_text__pqur5"};